import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Sidebar from "../shared/Sidebar";

function Equipment() {
  
 const baseUrl = process.env.baseUrl;
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    equipmentName: "",
    equipmentType: "",
    batchDuration: "",
    batchesPerDay: "",
    ratedPower: "",
    installationYear: "",
    manufacturer: "",
    comments: "",
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validate = () => {
    const newErrors = {};
    Object.entries(formData).forEach(([key, value]) => {
      if (!value.trim()) {
        newErrors[key] = "This field is required";
      }
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    try {
      await axios.post("/api/equipment", formData); // Replace with actual backend URL
      navigate("/"); // Redirect after success
    } catch (err) {
      console.error("Form submission error:", err);
      alert("Something went wrong. Please try again.");
    }
  };

  return (
    <div className="container col-lg-9 mt-5">
      <div className="row">
        <div className="col-md-4">
          <Sidebar />
        </div>

        <div className="col-md-8">
          <div className="form-section">
            <h5 className="mb-4">Major Batch Equipment</h5>
            <form onSubmit={handleSubmit}>
              <div className="row mb-3">
                {[
                  { name: "equipmentName", label: "Equipment Name" },
                  { name: "equipmentType", label: "Equipment Type" },
                  { name: "batchDuration", label: "Batch Duration" },
                  { name: "batchesPerDay", label: "Number of Batches / Day" },
                  { name: "ratedPower", label: "Rated Power" },
                  { name: "installationYear", label: "Year of Installation" },
                  { name: "manufacturer", label: "Manufacturer / Model" },
                  { name: "comments", label: "Comments / Issues" },
                ].map(({ name, label }) => (
                  <div className="col-md-12 mb-3" key={name}>
                    <input
                      type="text"
                      name={name}
                      className={`form-control ${errors[name] ? "is-invalid" : ""}`}
                      placeholder={label}
                      value={formData[name]}
                      onChange={handleChange}
                    />
                    {errors[name] && (
                      <div className="invalid-feedback">{errors[name]}</div>
                    )}
                  </div>
                ))}
              </div>

              <button type="submit" className="btn btn-custom w-100">
                Continue →
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Equipment;
